import * as React from "react"
import CardGrid from "../cardGrid"
import styled from "styled-components"
import CustomLink from "../customLink"

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  grid-template-rows: repeat(8, 1fr);
  grid-template-columns: 1fr;
  gap: 1em;

  & .title {
    grid-row: span 2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: max-content;
  }

  & .author {
    font-size: 16px;
    grid-row: span 1;
  }

  & .content {
    grid-row: span 4;
    max-height: 105px;
  }

  & .content p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .link {
    grid-row: span 1;
  }

  max-height: 275px;

  @media screen and (min-width: 768px) {
    display: grid;
    max-height: 402px;
    & .title {
      height: 78px;
    }
  }
`

const parseData = (data, limit) => {
  return data.map(item => JSON.parse(item.content_text)).sort((a, b) => new Date (b.pubDate) - new Date(a.pubDate)).slice(0, limit)
}

const DeveloperContent = ({ data, limit }) => {
  const cards = parseData(data, limit).map(item => ({
    content: (
      <StyledContent>
        <div className="title">
          <h3>{item.title}</h3>
        </div>
        <div className="author">
          <span>by {item.author_names}</span>
        </div>
        <div className="content">
          <p>{item.description}</p>
        </div>
        <div className="link">
          <CustomLink faux href={item.url} text="Read blog post" />
        </div>
      </StyledContent>
    ),
    link: item.url,
  }))

  return (
    <CardGrid
      cards={cards}
      cardWidth="360"
      border
      background="rgba(241, 240, 252, 0.35)"
    />
  )
}

export default DeveloperContent
